import { Component, Input, OnInit, ViewEncapsulation } from "@angular/core";
import { CmsData } from "@dotcom-frontend/data";
import {
  LgGridColDirective,
  LgGridContainerDirective,
  LgGridRowDirective
} from "@legal-and-general/canopy";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { WysiwygDirective } from "../../../directives/wysiwyg.directive";
import { ComponentLoaderService } from "../../../services/component-loader/component-loader.service";
import { GlobalState } from "../../../store/global/global.reducer";
import { selectPageTitle } from "../../../store/global/global.selectors";
import { DynamicComponentItem } from "../../utils/dynamic-loader/dynamic-component-item";
import { DynamicComponent } from "../../utils/dynamic-loader/dynamic.component";
import { LoaderComponent } from "../../utils/dynamic-loader/loader.component";
import { SafeHtmlPipe } from "../../utils/pipes/safe-html..pipe";
import { NgClass } from "@angular/common";

@Component({
  selector: "dotcom-frontend-text-block",
  templateUrl: "./TextBlock.component.html",
  encapsulation: ViewEncapsulation.None,
  styleUrl: "./TextBlock.component.scss",
  standalone: true,
  imports: [
    LgGridRowDirective,
    LgGridContainerDirective,
    LgGridColDirective,
    LoaderComponent,
    WysiwygDirective,
    SafeHtmlPipe,
    NgClass
  ]
})
export class TextBlockComponent implements DynamicComponent, OnInit {
  @Input() data: CmsData | undefined;
  parent = "";
  textBlockStyleStandard = false;
  textBlockStyle: string | undefined;
  textBlockBgColor = "";
  contentBgColor = "bg-color-";
  textBlockText: string | undefined;
  isInNarrowContentArea = false;
  contentLayout: string | undefined;
  pageTitle = "";
  followUpButtons: any;
  pageTitle$: Observable<string> = this.store.select(selectPageTitle);
  headingComponent: DynamicComponentItem | undefined;
  headingComponentTitle: DynamicComponentItem | undefined;
  headingComponentSubtitle: DynamicComponentItem | undefined;
  allowBackgroundFullWidthBleed = false;
  hasPadding = false;
  isInFullWidthContentArea = false;
  isInColumnContentArea = false;

  constructor(
    private store: Store<{ global: GlobalState }>,
    private componentLoaderService: ComponentLoaderService
  ) {
    this.pageTitle$.subscribe((title) => {
      this.pageTitle = title;
    });
  }

  async ngOnInit() {
    if (this.data) {
      this.contentLayout = this.data["contentLayout"];
      this.isInNarrowContentArea =
        this.contentLayout !== undefined && this.contentLayout !== "full";

      if (this.data && this.data["_showInModal"] === true) {
        this.isInNarrowContentArea = false;
      }
      if (this.data["parent"]) {
        this.parent = this.data["parent"];
      }

      this.textBlockStyle = this.data["layout"];
      this.textBlockStyleStandard = this.textBlockStyle === "standard";
      this.textBlockBgColor = this.data["backgroundColour"];
      this.textBlockText = this.data["text"];
      this.isInFullWidthContentArea = this.data["isInFullWidthContentArea"];
      this.isInColumnContentArea = this.data["isInColumnContentArea"];
      if (this.data["headingBlock"]) {
        if (this.textBlockStyleStandard) {
          this.headingComponent =
            await this.componentLoaderService.loadComponent(
              "Heading",
              "globals",
              {
                headingBlock: this.data["headingBlock"]
              }
            );
        } else {
          const headingTitle = {
            headingTitle: this.data["headingBlock"]["headingTitle"]
          };
          const headingSubtitle = {
            headingSubTitle: this.data["headingBlock"]["headingSubTitle"]
          };
          this.headingComponentTitle =
            await this.componentLoaderService.loadComponent(
              "Heading",
              "globals",
              {
                headingBlock: headingTitle
              }
            );

          this.headingComponentSubtitle =
            await this.componentLoaderService.loadComponent(
              "Heading",
              "globals",
              {
                headingBlock: headingSubtitle
              }
            );
        }
      }
      this.contentBgColor = this.contentBgColor + this.textBlockBgColor;

      if (this.data["allowBackgroundFullWidthBleed"]) {
        this.allowBackgroundFullWidthBleed = true;
      }

      if (this.data["followUpButton"]) {
        this.followUpButtons = [];
        for (const button of this.data["followUpButton"]) {
          const buttonComponent =
            await this.componentLoaderService.loadComponent(
              "Button",
              "globals",
              {
                ...button,
                blockId : this.data["contentLink"]["id"],
                adobeData: {
                  interactionContainer: "Text Block",
                  interactionLink: button["href"],
                  interactionName: button["text"],
                  interactionPage: this.pageTitle,
                  interactionRegion: "",
                  interactionType: "ButtonClick",
                  interactionDetails: ""
                },
              }
            );
          this.followUpButtons.push(buttonComponent);
        }
      }
    }

    this.setPadding();
  }

  setPadding() {
    if (
      !this.allowBackgroundFullWidthBleed &&
      !["white", "transparent"].includes(this.textBlockBgColor)
    ) {
      this.hasPadding = true;
    }
  }
}
